import React from 'react'
import { iconProps } from '../Helper'

export const UndoIcon = ({ className }: iconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <mask id="mask0_6684_81726" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <rect width="24" height="24" transform="matrix(-1 0 0 1 24 0)" fill="#D9D9D9"/>
        </mask>
        <g mask="url(#mask0_6684_81726)">
            <path className={className} d="M14.3799 18.5C15.8427 18.5 17.0956 18.0103 18.1386 17.0308C19.1816 16.0513 19.7031 14.8455 19.7031 13.4135C19.7031 11.9815 19.1816 10.7773 18.1386 9.801C17.0956 8.82467 15.8427 8.3365 14.3799 8.3365H7.35887L10.1414 5.55375L9.08762 4.5L4.50112 9.0865L9.08762 13.673L10.1414 12.6193L7.35887 9.8365H14.3799C15.4235 9.8365 16.3216 10.1794 17.0741 10.8652C17.8268 11.5512 18.2031 12.4007 18.2031 13.4135C18.2031 14.4263 17.8268 15.2773 17.0741 15.9663C16.3216 16.6554 15.4235 17 14.3799 17H7.20312V18.5H14.3799Z" fill="white"/>
        </g>
    </svg>
  )
}
